webpackJsonp([96203623897340],{

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(11);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _lodash = __webpack_require__(23);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(8);
	
	var _NotPublishedLocation = __webpack_require__(36);
	
	var _NotPublishedLocation2 = _interopRequireDefault(_NotPublishedLocation);
	
	var _Gmaps = __webpack_require__(35);
	
	var _Gmaps2 = _interopRequireDefault(_Gmaps);
	
	var _MainForm = __webpack_require__(30);
	
	var _MainForm2 = _interopRequireDefault(_MainForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//Components
	
	
	var MatagalpaEn = function (_Component) {
	  _inherits(MatagalpaEn, _Component);
	
	  function MatagalpaEn(props) {
	    _classCallCheck(this, MatagalpaEn);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      loading: true
	    };
	    return _this;
	  }
	
	  MatagalpaEn.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _axios2.default.get(_config.backendURL + '/api/locations/5beb22525ce849202700beca').then(function (res) {
	      var data = res.data;
	
	      console.log(data);
	      _this2.setState(_extends({
	        loading: false
	      }, data));
	      _axios2.default.get(_config.backendURL + '/api/banners/page/Locations').then(function (res) {
	        var main = res.data.filter(function (data) {
	          return data.section === 'Main';
	        });
	
	        _this2.setState(function (prevState) {
	          return _extends({}, prevState, {
	            loading: false,
	            mainImageEn: {
	              title: main[0].title,
	              url: main[0].imageEn
	            }
	          });
	        });
	      }).catch(function (err) {
	        console.log(err);
	      });
	    });
	  };
	
	  MatagalpaEn.prototype.renderImgs = function renderImgs() {
	    var _state = this.state,
	        images = _state.images,
	        title = _state.title,
	        lang = _state.lang;
	
	    if (!_lodash2.default.isEmpty(images)) {
	      return _lodash2.default.map(images, function (img) {
	        return _react2.default.createElement('img', {
	          key: title.en,
	          src: '' + _config.backendURL + img,
	          alt: title.en
	        });
	      });
	    }
	    return null;
	  };
	
	  MatagalpaEn.prototype.render = function render() {
	    var lang = this.props.pathContext.langKey;
	    var _state2 = this.state,
	        title = _state2.title,
	        address = _state2.address,
	        schedule = _state2.schedule,
	        type = _state2.type,
	        phone = _state2.phone,
	        waze = _state2.waze;
	
	    if (this.state.loading) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'page locations' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: 'Car Rental at Matagalpa | Budget Nicaragua',
	          meta: [{
	            name: 'description',
	            content: 'Frequently Asked Questions about car rentals. Contact Us'
	          }],
	          link: [{
	            rel: 'alternate',
	            hreflang: { lang: lang },
	            href: './es/locations/matagalpa/'
	          }]
	        },
	        _react2.default.createElement(
	          'script',
	          { type: 'application/ld+json' },
	          '{\n              \'@context\': \'http://schema.org\',\n              \'@type\': \'LocalBusiness\',\n              \'image\':\n                \'https://backend.budgetcentralamerica.com:5000/uploads/locations1534643033733.jpg\',\n              \'address\': {\n                \'@type\': \'PostalAddress\',\n                \'addressLocality\': \'Nicaragua\',\n                \'addressRegion\': \'Managua\',\n                \'streetAddress\': \'Pista Juan Pablo II, Frente A Enel Central\',\n                \'addressCountry\': \'Nicaragua\',\n              },\n              \'description\':\n                \'Budget Nicaragua, The Best Choice for Truck and Car Rental\',\n              \'name\': \'Budget Nicaragua, Aeropuerto Internacional La Aurora\',\n              \'telephone\': \'+505 2255-9000\',\n              \'openingHoursSpecification\': [\n                {\n                  \'@type\': \'OpeningHoursSpecification\',\n                  \'dayOfWeek\': [\n                    \'Monday\',\n                    \'Tuesday\',\n                    \'Wednesday\',\n                    \'Thursday\',\n                    \'Friday\',\n                  ],\n                  \'opens\': \'07:00\',\n                  \'closes\': \'21:00\',\n                },\n\n                {\n                  \'@type\': \'OpeningHoursSpecification\',\n                  \'dayOfWeek\': [\'Saturday, Sunday\'],\n                  \'opens\': \'07:00\',\n                  \'closes\': \'21:00\',\n                },\n              ],\n              \'geo\': {\n                \'@type\': \'GeoCoordinates\',\n                \'latitude\': \'12.124089393607338\',\n                \'longitude\': \'-86.27537727355957\',\n              },\n              \'sameAs\': [\n                \'https://www.facebook.com/BudgetNicaragua,\n                \n              ],\n            }'
	        )
	      ),
	      _react2.default.createElement(_MainForm2.default, {
	        image: this.state.mainImageEn,
	        pickupLocation: 1,
	        lang: lang
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'sidebar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'details' },
	            _react2.default.createElement(
	              'div',
	              { className: 'item title ' + type },
	              _react2.default.createElement('span', { className: 'icon' }),
	              _react2.default.createElement(
	                'h1',
	                null,
	                title[lang]
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item address' },
	              _react2.default.createElement('span', { className: 'icon' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                address[lang]
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item phone' },
	              _react2.default.createElement('span', { className: 'icon' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { style: { overflow: 'auto' } },
	                  _lodash2.default.map(phone, function (item, i) {
	
	                    var string_item = item.toString();
	
	                    var string_sin_espacio = string_item.replace(/\s/g, "");
	                    var string_phone = string_sin_espacio.replace('-', "");
	
	                    return _react2.default.createElement(
	                      'li',
	                      { key: i, style: { whiteSpace: 'nowrap' } },
	                      _react2.default.createElement(
	                        'a',
	                        { href: 'tel:' + string_phone },
	                        item
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item schedule' },
	              _react2.default.createElement('span', { className: 'icon' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                schedule[lang]
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'item waze' },
	              _react2.default.createElement('span', { className: 'icon' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: waze, target: '_blank' },
	                  'View on Waze'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'block gmap' },
	            _react2.default.createElement(_Gmaps2.default, {
	              lat: this.state.geolocation[0],
	              lng: this.state.geolocation[1]
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'gallery' },
	            this.renderImgs()
	          )
	        )
	      )
	    );
	  };
	
	  return MatagalpaEn;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = MatagalpaEn;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-locations-matagalpa-en-js-cc863b97abdd8a1126df.js